import QuestionList from "pages/QuestionPage/QuestionList/QuestionList";

export default QuestionList;
